import { apiGet, apiPost } from "./client";
import type { AccessResponse, MeResponse } from "@/types";

export function getMe(): Promise<MeResponse> {
  return apiGet<MeResponse>("/auth/me");
}

export function postAccess(email: string): Promise<AccessResponse> {
  return apiPost<AccessResponse>("/auth/access", { email });
}
